import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol"

import mapPin from '../../assets/images/map-pin.png'
import selectedMapPin from '../../assets/images/map-pin-selected.png'

import * as GraphicsLayer from './GraphicsLayer'
import type { GraphicsLayerHandle, GraphicHandle } from './GraphicsLayer'
import { AddressSearchResult } from "../../search/types"
import { LocationCandidate } from "../locator/types"

let layerHandle: GraphicsLayerHandle = GraphicsLayer.NULL_LAYER_HANDLE

const selectedSymbol = new PictureMarkerSymbol({
  url: selectedMapPin,
  width: 24,
  height: 24,
  xoffset: 0,
  yoffset: 24,
})

const unselectedSymbol = new PictureMarkerSymbol({
  url: mapPin,
  width: 24,
  height: 24,
  xoffset: 0,
  yoffset: 24,
})

export const initLocatorLayer = (map: __esri.Map, view: __esri.MapView) => {
  layerHandle = GraphicsLayer.createGraphicsLayer(map, view)
}

const createGraphic = (candidate: LocationCandidate): GraphicHandle => {
  const handle = GraphicsLayer.createGraphic(layerHandle, { address: candidate.label }, candidate.location, unselectedSymbol)
  return handle
}

export const addCandidates = (candidates: LocationCandidate[]): AddressSearchResult[] => {
  if (layerHandle === GraphicsLayer.NULL_LAYER_HANDLE) return []

  let graphicHandles = []
  let results: AddressSearchResult[] = []
  for (let i = 0; i < candidates.length; i++) {
    const candidate = candidates[i]
    const handle = createGraphic(candidate)
    graphicHandles.push(handle)
    results.push({ 
      type: 'Address', 
      handle, 
      label: candidate.label, 
      location: candidate.location,
    })
  }
  GraphicsLayer.addGraphics(layerHandle, graphicHandles)
  return results
}

export const highlightGraphic = (handle: GraphicHandle) => {
  if (layerHandle === GraphicsLayer.NULL_LAYER_HANDLE) return
  GraphicsLayer.updateGraphicSymbol(layerHandle, handle, selectedSymbol)
}

export const unhighlightGraphic = (handle: GraphicHandle) => {
  if (layerHandle === GraphicsLayer.NULL_LAYER_HANDLE) return
  GraphicsLayer.updateGraphicSymbol(layerHandle, handle, unselectedSymbol)
}

export const clearGraphics = () => {
  if (layerHandle === GraphicsLayer.NULL_LAYER_HANDLE) return
  GraphicsLayer.clearGraphics(layerHandle)
}